"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumeric = isNumeric;

function isNumeric(val) {
  let num = Number(val);

  if (!isNaN(num) && val !== "") {
    return true;
  } else {
    return false;
  }
}